import termotanque1 from './Img/termotanque1.jpg';
import termotanque2 from './Img/termotanque3.jpg';

function TermotanqueSolar() {

  return (
    <><br/><br/><br/><br/><br/>
   <div class="d-flex w-100" id="termotanquesolar">
    <div class="row align-self-center  px-5 text-white">
        <h1 class="mt-5">Agua caliente</h1>
        <h4 class="text-white text-opacity-75">en tu casa con los</h4>
        <h2 class="">TERMOTANQUES SOLARES</h2>
    </div>
</div>
<br />
<div class="row w-100">
    <div class="col-6" id="termotanqueimg"><img class="img-fluid  h-100"
            src={termotanque1}/></div>
    <div class="col-6" id="termotanque">
        <div class="container termotanque">
            <div class="card-title">
                <h2 class="termotanquetitulo">TERMOTANQUES NO PRESURIZABLES</h2>
            </div>
            <div class="row p-2">
                <div class="col-4 bg-secondary bg-opacity-50"><b>Modelo</b></div>
                <div class="col-7 bg-secondary bg-opacity-50"><b>Capacidad</b></div>
                <div class="col-4">SGJ100</div>
                <div class="col-4"> para 2 a 3 personas</div>
                <div class="col-3">100L</div>
                <div class="col-4 bg-secondary bg-opacity-50">SGJ150</div>
                <div class="col-4 bg-secondary bg-opacity-50"> para 3 a 4 personas</div>
                <div class="col-3 bg-secondary bg-opacity-50">150L</div>
                <div class="col-4">SGJ200</div>
                <div class="col-4"> para 4 a 5 personas</div>
                <div class="col-3">200L</div>
                <div class="col-4 bg-secondary bg-opacity-50">SGJ300</div>
                <div class="col-4 bg-secondary bg-opacity-50"> para 6 a 7 personas</div>
                <div class="col-3 bg-secondary bg-opacity-50">300L</div>
            </div>
        </div>
    </div>
</div>
<br />
<div class="row p-2 w-100">
    <div class="col-6" id="termotanque">
        <div class="container termotanque">
            <div class="card-title">
                <h2 class="termotanquetitulo">TERMOTANQUES PRESURIZABLES</h2>
            </div>
            <div class="row">
                <div class="col-4 bg-secondary bg-opacity-50"><b>Modelo</b></div>
                <div class="col-7 bg-secondary bg-opacity-50"><b>Capacidad</b></div>
                <div class="col-4">HPJ200</div>
                <div class="col-4"> para 4 a 5 personas</div>
                <div class="col-3">200L</div>
                <div class="col-4 bg-secondary bg-opacity-50">HPJ300</div>
                <div class="col-4 bg-secondary bg-opacity-50"> para 6 a 7 personas</div>
                <div class="col-3 bg-secondary bg-opacity-50">300L</div>
            </div>
        </div>
    </div>
    <div class="col-6" id="termotanqueimg"><img class="img-fluid termotanqueimg h-100"
            src={termotanque2}/></div>
</div>
    </>
  )
}

export default TermotanqueSolar